import React, { Component } from 'react'
import DevTool from 'mobx-react-devtools'
import config from 'config.json'

export default class App extends Component {
  render () {

    const { params } = this.props
    if (typeof window !== 'undefined' && params.exam === 'gmat') {
      window.location.href = `${config.site.zhike}/error/404.html`
      return
    }

    return (
      <div>
        { this.props.children }
        {
          process.env.NODE_ENV === 'development'
            ? <DevTool position={{ top: 0, left: 20 }} />
            : null
        }
      </div>
    )
  }
}



/** WEBPACK FOOTER **
 ** ./src/App.js
 **/